<template>
    <div id="personal_intru">
        <div class="close-btn">
            <button @click="close"><v-img src="@/assets/img/closeButton2.svg"></v-img></button>
        </div>
        <div class="content-wrap">
            <div class="title"><p>목소리의 행방</p></div>
            <div class="content">
                사정이 있어서 함께 소풍을 가지 못한 친구가 있다면 그날 이야기를 삼가게 된다. 하지만 동행한 친구에게는 경험에 대해 단정적으로 판단하기가 쉽다. 그때 더웠지, 좋았지, 배고팠지, 황당했지, 아무것도 아닌 날이었지. 네가 대답할 수 있는 범주는 내가 이미 알아. 모두 함께 참여한 일에 대해서는 곧잘 경솔해진다. 
<br>
<br>
그만큼 가벼운 마음이었다. 학생회는 이틀에 걸쳐 사운드 메이트 발표를 문자로 넣어준 것 같았다. 미사는 나보다 하루 전에 연락을 받았는데, 어떻게 됐나 이야기를 해주는 대신에 문자를 보여줬다. [김미사님의 고유 사운드는 ‘<span class="sound_text_visited" :class="{'sound-text' : visited[12] === 'disabled'}" @click="play('오렌지')">오렌지</span>’이며 총 17명의 사운드 메이트와 연결되었습니다. 1학년 3반 한유리 010...] 
<br>
<br>
“개빡친다. 뭔 오렌지를, 17명이나 듣냐?”
<br>
<br>
그만한 숫자는 메이트라고 하기에는 무리가 있었다. 미사는 같은 반에서 겹친 친구 하나, 걔가 소개시켜준 옆 반 오렌지 친구. 이렇게 둘과 하이파이브만 한 번 하고 말아버렸다. 목록을 주섬주섬 외울 의욕이 나지 않을 인원이었다. 내가 사운드 메이트 행사에서 짐작한 불행이란 고작 이런 정도였다. 별 쓸데없는 짓을 했다는 생각이 들만큼 내키지 않은 사람과 찝찝한 이름으로 맺어지거나, 집합 안의 인원이 너무 많아서 김빠지는 것. 그래서 안일했다는 걸 인정한다.
<br>
<br>
“이리에. 연락 왔어?”
<br>
<br>
“뭐가. 사운드 메이트?” 
<br>
<br>
“어.”
<br>
<br>
김이리에는 입을 합 다물고 입술 사이만 우물거렸다. 웃는 것 같기도 하고, 곤란해 보이는 것 같기도 했다. 일반적인 전개대로 되지 않은 건 확실하다. 마음에 안 드는 운명의 짝과 17인의 동료 중에 어느 쪽일까? 이리에는 한참 딴청을 피우다가, 대답을 기다리는 나의 낌새에 입을 열었다. 
<br>
<br>
“그런 거 중요해?” 
<br>
<br>
“뭐라고?”
<br>
<br>
비호의적으로 들리는 어조에 당황하고 말았다. 이리에는 크게 고조된 지점 없이 나를 봤다. 시각과 청각으로 느껴지는 그의 온도가 서로 달라서 무슨 의도인지 갈피를 잡기 어려웠다.
<br>
<br>
“사운드 메이트가 생기면 걔를 특별하게 대해줄 거야?”
<br>
<br>
“잠깐 반가워하다가 말겠지.” 
<br>
<br>
난 원래 그런 애니까. 뒷 문장은 속으로만 한번 말해봤다.
<br>
<br>
“그러면, 사운드 메이트 찾기는 왜 참여했어?”
<br>
<br>
“잠깐 반가워하려고. 시비 터는 거 재미 좋은가봐?”
<br>
<br>
배드민턴공을 주고받듯이 서로의 라켓에 대답이 부딪혔다. 마지막으로 스매쉬를 날렸다. 이리에는 공을 놓치며 웃었다. 그의 등 뒤로 굴러가는 공을 돌아보지 않았다. 단지 갑작스런 랠리 발생의 사유를 알려줬다.
<br>
<br>
“나는… 단어가 하나도 안 들리더라. 아주 작고 날개가 달린 것들이 내 주변을 공격적으로 날아다니는 소리만 웅웅거렸어.” 
<br>
<br>
<br>
<br>
나의 사운드 메이트는 한 학년 위의 선배였다. [우표친구야~ㅋㅋ 반가워 학교에서 마주치면 인사하자] 그가 먼저 문자를 보냈다. 선배와의 조우는 매점에서 이루어졌다. 학년과 이름을 알 수 있는 명찰을 보고는 그쪽에서 먼저 아는 체를 했다. 그리고는 피자빵과 딸기우유를 사줬다. 학년이 끝날 때쯤 갑자기 연락해서 풀지 않은 문제집을 물려주기도 했다. 그 사이기간에는 가깝지 않았다. 축제 이벤트로 찾은 사운드 메이트란 그 정도의 인연이었다. 있어도 그만, 없어도 그만. 
<br>
<br>
그러나 이리에는 이 일을 오래 기억에 남겼던 모양이었다. 사운드 메이트를 찾는 어두운 암실의 장면은 이리에가 드물게 미련을 가진 채로 <span class="sound_text_visited" :class="{'sound-text' : visited[13] === 'disabled'}" @click="play('지피죽')">멈춰 있는 세계</span>처럼 보였다.
<br>
<br>
객관적으로 가엾을 일은 아니다. 그러나 마음이 좋지 않았다. 위로를 위해 무언가 한 마디 덧붙이자니 그것도 까마득했다. 이리에가 그 암실의 순간에 부여한 무게와 의미는 나와 너무 다를 거니까. 빈 상자를 들고 무겁다고 증언하는 것처럼 너무 티가 날 것 같았다. 내가 그 앞에서 느꼈던 막막함은, 인간이 인간을 필요로 하는 순간을 목격했을 때의 무망감이다. 물건이나 경험을 필요로 하는 사람과는 비교가 되지 않는다. 그런 이들을 달래줄 방법은 없다. 그래서 나는 김이리에가 ‘사람들’을 찾아 나서는 일을 적극적으로 만류하지도 부추기지도 못했다. 단지 묵묵하게 참여를 했다. 
<br>
<br>
음향원을 졸업하고, 그는 세상 전체를 대상으로 그와 같은 주파수를 듣는 사람들을 찾겠다는 이야기를 들려줬다. 나는 이리에의 주파수 안에 나의 우표는 존재하지 않을 것임을 알았다. 
<br>
<br>
            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/plugins/eventbus.js'
import store from "@/store/index.js";

export default {
  name: 'index_five',
  data() {
    return {
        visited : {
            12: store.getters['getMusicIconUsable'](12),
            13: store.getters['getMusicIconUsable'](13), 
        },
        
    }
  },
  methods: {
    close() {
        this.$emit("btnclose");
    },
    play(message) {

        switch(message) {
            case '오렌지' :      
                store.commit("toggleText", 12)
                eventBus.$emit("iconUsable", 12); 
                this.visited[12] = 'active'
                break; 
            case "지피죽" :
                store.commit("toggleText", 13)
                eventBus.$emit("iconUsable", 13); 
                this.visited[13] = 'active'
                break;
        }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
display: none;
}

#personal_intru {
  box-sizing: border-box;

  position: absolute;
  height: 649px;
  width: 500px;

  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);

  background: rgba(26, 26, 26, 0.9);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 20px;

  left: 756px;
  top: 150px;

  text-align: center;
}

.close-btn {
    position: relative;
    height: 16px;
    width: 16px;
    left: 16px;
    top: 16px;
    border-radius: 16px;
}
.content-wrap {
    position : relative;

    left: 60px;
    top: 64px;
    height: 569px;
    width: 380px;

    overflow-y: scroll;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #F1F1F1;

}

.content {
    margin-top: 58px;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 200%;
    /* or 36px */

    text-align: justify ;
    color: #F1F1F1;

}
@media (max-width: 600px) {

    #personal_intru {
        top: 500px;
        left: 0;
        width: 100vw;
        height: 600px;
        
    }

    .content-wrap {
        left: 45px;
        width: 310px;
        height: 510px;
    }
    
    .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #EAEAEA;


    }

    .content {
        width: 310px;
        height: 510px;
        font-weight: 600;
        font-size: 14px;
        line-height: 200%;
        color: #EAEAEA;

    }
}

</style>